import { fetchEligibilityCouponConfig } from 'common/api/coupons';
import { useEffect, useState } from 'react';
import { CouponResponse, SuccessCouponResponse } from './type';
import moment from 'moment';
import _ from 'lodash';

const UserAssociationsCouponCard = () => {
  const [couponDetails, setCouponDetails] = useState<SuccessCouponResponse | null>(null);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const response: CouponResponse = await fetchEligibilityCouponConfig();
        if (response.status) setCouponDetails(response);
      } catch (err) {
        console.error('Error fetching welcome coupon:', err);
      }
    };

    fetchCoupon();
  }, []);

  if (_.isEmpty(couponDetails?.coupon)) return null;

  const {
    discount_percentage: discountPercentage,
    code,
    valid_till: couponValidTill = null,
  } = couponDetails.coupon;

  const { message: couponMessage = '', type: couponType } = couponDetails.config;
  const planQueryString = _.isEqual(couponType, 'BeforePlanExpiredCoupon') ? 'upgradeCode' : 'referralCode';

  return (
    <div className="user-coupon">
      <div className="user-coupon__content">
        <span className="user-coupon__content__text">
          Get <span className="user-coupon__content__text__percentage">{discountPercentage}%</span> Off On
          {couponMessage} Coupon:
        </span>
        <span className="user-coupon__content__code">{code}</span>
        <button
          className="track"
          data-track-category="New User Coupon"
          data-track-action="Apply Coupon"
          data-track-label={code}
          onClick={() => (window.location.href = `/plans?locale=en&${planQueryString}=${code}`)}
        >
          Apply Coupon
        </button>
        {couponValidTill && <span>Valid till: {moment(couponValidTill).format('MMM Do, YYYY')}</span>}
      </div>
    </div>
  );
};

export default UserAssociationsCouponCard;
